/**
 * Encode r buffer into rgba buffer
 * @param values - Desc
 * @returns
 */
export const encodeRtoRGBA = (r: Float32Array): Float32Array => {
  const n = r.length;
  const rgba = new Float32Array(n * 4);

  for (let i = 0; i < n; i++) {
    rgba[i * 4] = r[i];
    rgba[i * 4 + 1] = 0;
    rgba[i * 4 + 2] = 0;
    rgba[i * 4 + 3] = 1;
  }

  return rgba;
};
